export const SparkEvent = {
  SparkPageView: 'spark_page_view',
  GnbSparkClick: 'gnb_spark_click',
  EarnSparkPageView: 'earn_spark_page_view',
  EarnSparkPageDepositClick: 'earn_spark_page_deposit_click',
  EarnSparkPageTradeClick: 'earn_spark_page_trade_click',
  EarnSparkPageMultiplierInfoClick: 'earn_spark_page_multiplier_info_click',
} as const;

export interface SparkEventDataType {
  [SparkEvent.SparkPageView]: {};
}
